define(function(require,exports,module){
    var RenderCanvas= require( './render/Canvas' ),
        RenderDom   = require( './render/Dom' ),
        RenderSVG   = require( './render/Svg' ),
        Scaler      = require( './helpers/Scaler' ),
        Pitch       = require( './workers/Pitch' ),
        config      = require( './enums/config' ),
        merge       = require( './helpers/merge' ),
        cssClass    = require( './helpers/cssClass' ),
        domHelper   = require( './helpers/domHelper' );


    function PitchLayer(options){

        if(!(this instanceof PitchLayer)){
            return PitchLayer.create(options);
        }
        this.teams={};
        this.pitchIds = {};
        this.pitches=[];
        this.pitchGrid=[];
        this.config=merge({},config,options);
        this.options = options;
        this.scale();

        if(this.config.vector===true && 'SVGAngle' in window){
            this.render=new RenderSVG(this);
        } else{
            this.render=new RenderCanvas(this);
        }
        this.dom=new RenderDom(this);

        if(this.config.type==='side'){
            this.viewAngle=90;
        }

        this.atbat={}
        this.lastAtbat = {};
    };

    PitchLayer.create = function(options){
        return new PitchLayer(options);
    };

    /**
     * Configure all instances of PitchLayer
     * @param  {object}     opts    Config properties to apply to
     *                              all instances of PitchLayer
     * @see  ../enums/config.js
     * @return {object}             All configured options.
     */
    PitchLayer.config = function (opts) {
        merge(config,opts);
        return config;
    };

    PitchLayer.prototype={
        view        : null,
        output      : null,
        viewAngle   : 0,
        anchored    : false,
        drawn       : false,
        fetched     : false,
        pitchCount  : 0,
        refreshOnBeat : false,
        hidden      : true,


        scale  : function (w) {
            this.scalers=new Scaler(w, this.options);
            if(this.render){
                this.render.scalers=this.scalers;
            }
            if(this.dom){
                this.dom.scalers=this.scalers;
            }

            return this.scalers;
        },
        drawBall : function(p, pt, pt2){
            this.render.drawBall(p, pt, pt2);
            this.dom.drawBall(p, pt, pt2);
        },

        ensurePitches: function(){
            var pitches=[],
                pitchesOrAtbat=this.atbat;

            if(pitchesOrAtbat.pitches){
                pitches=pitches.concat(pitchesOrAtbat.pitches);
            }else if(!Array.isArray(pitchesOrAtbat)){
                if(pitchesOrAtbat.isPitch){
                    pitches=pitches.concat(pitchesOrAtbat);
                }
            }else{
                pitches=pitchesOrAtbat;
            }
            this.pitches=pitches;
            return pitches;
        },

        ensureBatter: function(){
            var batter = this.atbat.batter || {};
            var lastBatter = this.lastAtbat.batter || {};
            var batterId = batter.person && batter.person.id;
            var lastBatterId = lastBatter.person && lastBatter.person.id;

            // Pinch hitter, switch stance - we got it all covered.
            return (this.atbat.uniformData ? this.atbat.uniformData.isLoading !== true : true) &&
                ((batterId ? batterId !== lastBatterId : batter !== lastBatter) ||
                (this.atbat.stand !== this.lastAtbat.stand) ||
                (this.atbat.uniform !== this.lastAtbat.uniform) ||
                (this.atbat.uniformData.fullSet !== this.lastAtbat.uniformData.fullSet));
        },

        parsePitches : function(){
            // Clear atbat if there currently isn't one, or its a different one from previous
            // (dont clear if its the first atbat coming from warmup even though "0 !== null")
            if(!this.atbat || this.atbat.num > 0 && this.atbat.num!==this.lastAtbat.num){
                this.clearAtbat();
            }
            this.ensurePitches();
        },
        draw2Dpitch : function(){
            this.render.draw2Dpitch();
        },

        draw3dPitch : function(){
            this.render.drawPitch();
        },

        clearAtbat : function(){
            this.clearPitches();
            this.isStrikeZoneDrawn = false;
        },

        clearPitches: function() {
            this.clearPitchIds();
            this.render.clear();
            this.dom.clear();
        },

        clearAll : function () {

            this.atbat = {};
            this.lastAtbat={};

            this.clearAtbat();
        },

        resize : function () {
            var w;
            if (this.view) {
                w = (this.config.fixed_width || this.dom.sizer.offsetWidth) * this.scalers.canvasDensity;

                if(this.scalers.width < ~~w){
                    this.clearPitchIds();
                    this.scale(w);
                    this.render.resize();
                    this.dom.resize();
                }
            }
        },

        anchor : function (view) {
            var that=this;
            var config = this.config;

            if (this.view!==view) {
                var isImg = view && (view.nodeName||"").toLowerCase() === 'img';

                if(config.renderURI === true || isImg){
                    config.renderURI = true;
                    config.hoverData = false;
                    config.batter    = false;
                    this.output = isImg && view;

                    if(!this.anchored){
                        view = document.createElement('div');
                        view.className=cssClass() + " " + cssClass('offscreen');
                        domHelper.append(document.body, view);
                    }
                }
                if(!this.anchored && config.fixed_width){
                    view.style.width=config.fixed_width + 'px';
                    view.style.height=config.fixed_height + 'px';
                }
                this.view=view;
                this.view.className += " " + cssClass()
                    + (config.tiltShift ? " " + cssClass("tilt-shift") : "")
                    + (config.oldTimey ? " " + cssClass("old-timey") : "")
                    + (config.perspective === 'pitcher' ? " " + cssClass("perspective-pitcher") : "");

                if(config.diagnostics){
                    this.view.setAttribute("data-responsive-pitch-fx-diagnostics",true);
                }

                this.anchored = true;
                this.clearAll();
                that.dom.anchor();
                that.render.anchor();
                this.resize();
            }
            return this;
        },

        isDrawn: function () {
            return this.anchored && this.drawn;
        },

        drawTo : function(view, atbat, hotcold, clear){
            this.anchor(view);
            this.draw(atbat, hotcold, clear);
        },

        draw: function (atbat,hotcold,clear) {
            if(typeof hotcold==='boolean'){
                clear=hotcold;
                hotcold=null;
            }
            if(clear){
                this.clearAll();
            }
            
            this.resize();
            
            // stash this
            this.lastAtbat = this.atbat;
            //update the reference
            this.atbat = atbat || this.atbat;
            this.hotcold = hotcold;
            if (this.config.batter && this.ensureBatter()) {
                this.dom.drawBatter();
            }
            this.parsePitches();
            this.drawPitches();

            return this;
        },

        drawPitches : function(){
            // might be a fat lotta nuthin'
            var that=this;
            var atbat = this.atbat;
            var pitch;
            var pitches=that.pitches;
            var i=0;
            var len=pitches.length;
            var pitchId;

            if (len === 0) {
                return;
            }
            var pitchIds = this.pitchIds;

            for(; i < len; i++){
                pitch = pitches[i]
                pitchId = (pitch.playId || (atbat.num + '-' + pitch.index));
                if(pitch.details && pitch.details.code){
                    pitchId += '-' + pitch.details.code;
                } 
                if (pitch.isPitch && !pitchIds[pitchId]) {  //see if pitch drawn already
                    var pitch = new Pitch(pitch,this.render);
                    this.pitchIds[pitchId] = pitch;
                    that.render.drawHistory();
                    that.render.drawPitch(pitch);
                    that.dom.drawPitch(pitch);
                }
            }

            this.render.run();
            this.pitches=[];
        },

        renderImage : function(){
            var img = this.render.renderImage();
            if(this.output){

                this.output.src = img;
            }
            return img;
        },
        render : function (pitches, pctr, atbat) {
            this.render.render();
        },

        destroy: function (keep) {
            this.clearAll();
            if (keep !== true) {
                this.render.destroy();
                this.dom.destroy();
            }
            this.anchored = false;
            this.drawn = false;

        },

        clearPitchIds: function() {
            this.pitchIds = {};
            this.render.scheduler.clear();
        }
    };

    return PitchLayer;
});
